/** Узкий экран.
 *
 * Порог в 340 px взят не из ряда популярных ширин, а из правила зоны
 * нажатия: ниже него девять клавиш в один ряд дают около 28 px на клавишу,
 * и минимум в 44 px нарушается. Поэтому клавиатура переходит в две строки
 * 5+4 — перестроить раскладку дешевле, чем заставлять промахиваться.
 *
 * Проверять приходится в JS, а не в CSS: медиазапрос умеет менять размеры,
 * но не умеет переносить пятую клавишу в другую строку так, чтобы девятая
 * позиция осталась пустой ради ровной решётки.
 */

import { useEffect, useState } from 'react'

export const NARROW_WIDTH = 340

export function useNarrowScreen(maxWidth: number = NARROW_WIDTH): boolean {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= maxWidth,
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const query = window.matchMedia?.(`(max-width: ${maxWidth}px)`)
    const update = () => setNarrow(query ? query.matches : window.innerWidth <= maxWidth)

    update()
    // Слушаем и медиазапрос, и resize: при повороте экрана в вебвью
    // Telegram событие change приходит не на всех платформах, а
    // клавиатура, оставшаяся в один ряд, — это промахи по клавишам.
    query?.addEventListener('change', update)
    window.addEventListener('resize', update)
    return () => {
      query?.removeEventListener('change', update)
      window.removeEventListener('resize', update)
    }
  }, [maxWidth])

  return narrow
}
